// Copyright (c) 2025 TrustCloud Corporation - All rights reserved.
//
// This software contains valuable confidential and proprietary information of
// TrustCloud Corporation
//
// Unauthorized use, reproduction, transmission, or distribution of this file and its
// contents is a violation of applicable law.

// Package modules
import React from 'react';
import styled from '@emotion/styled';

// Locale modules
import { Flex } from './Flex';
import { BREAKPOINTS } from '../lib/constants';

// Assets
import TrustCloudFooterBranding from './TrustCloudFooterBranding';
import SocialMediaFooterLinks from './SocialMediaFooterLinks';

// Styled components
const Footer = styled(Flex)`
  flex-grow: 0; // Restrict the footer from growing
  margin-top: auto;
  flex-direction: column-reverse;
  gap: 20px;

  padding: 1rem;

  background-color: white;
  background-size: cover;

  @media (min-width: ${BREAKPOINTS.TABLET}px) {
    & {
      flex-direction: row;
      justify-content: space-between;
      padding: 1.5rem 3rem;
    }
  }
`;

export function AppFooter() {
  return (
    <Footer
      as="footer"
      justifyContent="space-between"
    >
      <TrustCloudFooterBranding />
      <SocialMediaFooterLinks />
    </Footer>
  );
}
